import React, { useState, Fragment, useCallback } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import ProductCard from '../../tissues/product-card';
import QuickShop from '../../tissues/product-quick-shop';
import { DEFAULT_COUNT } from '../../organisms/products';
import { updateScrollY, updatePages } from '../../store/modules/products/actions';

const Grid = styled.section`
  display: grid;
  grid-area: products;
  grid-gap: 1.5rem;
  grid-template-columns: repeat(2, 1fr);
  position: relative;

  img {
    display: block;
    max-width: 100%;
  }

  & ~ & {
    margin-top: 5rem;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoint.medium}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const ProductGrid = (props) => {
  const [quickshop, setQuickshop] = useState(null);

  const setProductScrollPosition = useCallback(() => {
    global.document.cookie = `savedPage=${props?.savedPage?.current?.name ?? 1}; path=/;`;

    const scrollPos = global.document?.documentElement?.scrollTop
      ?? global.document?.body?.scrollTop;
    props.updateScrollY(scrollPos);
    props.updatePages(props.savedPage);
  }, [props.savedPage]);

  return (
    <Grid>
      {
        props.products.map((product, i) => {
          const renderObserver = props.intersectionInterval
            && (i % props.intersectionInterval === 0);
          const observerPosition = renderObserver && i / props.intersectionInterval;

          return (
            <Fragment key={product.maisonette_product_id}>
              <ProductCard
                taxonProducts={props.taxonProducts}
                product={product}
                index={i + 1}
                onClick={setProductScrollPosition}
                onQuickshopClick={setQuickshop}
                disableLazyload={i < DEFAULT_COUNT}
                module="plp"
                intersectionPosition={renderObserver && observerPosition}
                intersectionCallback={
                  renderObserver ? () => props.intersectionCallback(observerPosition) : null
                }
              />

              {
                quickshop === product.maisonette_product_id && (
                  <QuickShop
                    position={i + 1}
                    slug={product.url.split('/')[product.url.split('/').length - 1]}
                    quickShopIndex={i + 1}
                    onQuickshopClose={() => setQuickshop(null)}
                  />
                )
              }
            </Fragment>
          );
        })
      }
    </Grid>
  );
};

ProductGrid.defaultProps = {
  updateScrollY: () => {},
  savedPage: {},
  updatePages: () => {},
  intersectionInterval: 0,
  intersectionCallback: () => {},
  taxonProducts: true
};

ProductGrid.propTypes = {
  products: PropTypes.array.isRequired,
  updateScrollY: PropTypes.func,
  savedPage: PropTypes.object,
  updatePages: PropTypes.func,
  intersectionInterval: PropTypes.number,
  intersectionCallback: PropTypes.func,
  taxonProducts: PropTypes.bool
};
const mapStateToProps = (state) => ({
  scrollPosition: state.products.scrollY,
  savedPage: state.products.pages
});

const mapDispatchToProps = (dispatch) => ({
  updateScrollY: (scrollY) => dispatch(updateScrollY(scrollY)),
  updatePages: (pages) => dispatch(updatePages(pages))
});

const ConnectedProductGrid = connect(mapStateToProps, mapDispatchToProps)(ProductGrid);

ProductGrid.displayName = 'ProductGrid';

export default ConnectedProductGrid;
